<template>


<v-container>
<!--   <div class="about">
    <h1>PRINT</h1>
  </div> -->


    <v-layout align-center justify-center row wrap>
      <v-flex lg2 xs12 ma-1
        v-for=" (itemBtn , nB) in dataItemsEdit[0].items"
        :key="'k-'+nB"
        v-if="itemBtn.viewItem"
      >


      <v-img
      :src="itemBtn.urlImg"
      aspect-ratio="2"
      @click="goToPage(nB)"
      >

      </v-img>


      </v-flex>
      <v-flex lg10 xs12 ma-1>
                <Adsense
                    data-ad-client="ca-pub-2917438270060687"
                    data-ad-slot="1935669250">
                </Adsense>

      </v-flex>
    </v-layout>



  </v-container>


</template>



<script>

import axios from "axios";
import { mapState } from "vuex";
import router from "../router";



  export default {
    name: "PrintItems",
  metaInfo: {
    title: 'Работы для печати',        
    meta: [      
      { name: 'description', content: 'Он-лайн редактор работ для печати' }
    ],
    titleTemplate: '%s - Cardolini'
  },    
    data: () => ({

    }),
    mounted() {
    console.log("monted Print");

    this.$store.commit("koeffOver", 1);
    this.$store.commit("titleHead", "Работы для печати");

  },
      computed: {
          koeffOver() {
            return this.$store.state.koeffOver;
          },
          koeff() {
            return this.$store.state.koeff;
          },
          currNumItem() {
            return this.$store.state.currNumItem;
          },
          currentItem() {
            return this.$store.state.currentItem;
          },
          printItem() {
            return this.$store.state.printItem;
          },
          hCanvas() {
            return this.$store.state.hCanvas;
          },
          wCanvas() {
            return this.$store.state.wCanvas;
          },
          titleHead() {
            return this.$store.state.titleHead;
          },
          dataItemsEdit() {
            return this.$store.state.dataItemsEdit;
          },
          libBGTest() {
            return this.$store.state.libBGTest;
          },
        },
      methods: {

        goToPage: function(namePage) {
          console.log("gotoPage = ", namePage);
          console.log("width = ", this.dataItemsEdit[0].items[namePage].width*this.koeff);
          console.log("height = ", this.dataItemsEdit[0].items[namePage].height*this.koeff);
if(this.dataItemsEdit[0].items[namePage].width*this.koeff > 1000){
  //this.localCoeffOver = 1000/this.dataItemsEdit[1].items[namePage].width;
  this.$store.commit("currNumItem", namePage);
  this.$store.commit("koeffOver", 1000/(this.dataItemsEdit[0].items[namePage].width*this.koeff));
  console.log("koeffOver = ", this.koeffOver);
  console.log("Ширина больше 1200 px. Делаем ширину = ", this.dataItemsEdit[0].items[namePage].width*this.koeff*this.koeffOver);
  console.log("Ширина больше 1200 px. Делаем высоту = ", this.dataItemsEdit[0].items[namePage].height*this.koeff*this.koeffOver);
}

          this.$store.commit("currentItem", this.dataItemsEdit[0].items[namePage]);
          this.$store.commit("titleHead", this.dataItemsEdit[0].items[namePage].title);

          this.$store.commit("wCanvas", this.dataItemsEdit[0].items[namePage].width*this.koeff*this.koeffOver);
          this.$store.commit("hCanvas", this.dataItemsEdit[0].items[namePage].height*this.koeff*this.koeffOver);

                    router.push('editor/'+this.currentItem.itemN);

        },

  },
  }



</script>
